import { AvatarImage } from "@/components/ui/avatar";
import { useProfileImageUrl } from "@/features/profile/hooks/use-profile-image-url";

/**
 * A user's profile image inside an `<Avatar>`, loaded through an API-signed URL.
 *
 * `profileImagePath` is a Storage path, not something a browser can load, so
 * the image only renders once the API has signed it for this viewer. Until
 * then, or when the viewer may not see it, the avatar's `AvatarFallback`
 * shows instead. Avatars rendered together share one signing call.
 */
export function ProfileAvatarImage({
  userId,
  profileImagePath,
  alt,
}: {
  userId: string;
  profileImagePath: string | null | undefined;
  alt?: string;
}) {
  const url = useProfileImageUrl({ userId, profileImagePath });
  if (!url) {
    return null;
  }
  return <AvatarImage src={url} alt={alt} />;
}
